import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import Modal from '../Modal';
import moment from 'moment';
import ReactLoading from 'react-loading';

const base = 'live-dispatch';

@inject('LiveDispatchStore')
@observer
class DriveThrough extends Component {
    state = {
        hours: '--',
        minutes: '--',
        seconds: '--',
        delay: false,
        showConfirmationModal: false,
        loading: false
    };

    componentDidMount = () => {
        this.setCountdown();
    };

    componentDidUpdate = (prevProps) => {
        const { order } = this.props;
        if (order.delivery_date !== prevProps.order.delivery_date) {
            this.resetCountdown();
            this.setCountdown();
        }
    };

    componentWillUnmount() {
        this.resetCountdown();
    }
    
    resetCountdown = () => {
        if (this.interval) clearInterval(this.interval);
        this.setState({
            hours: '--',
            minutes: '--',
            seconds: '--',
            delay: false,
        });
    };

    setCountdown = () => {
        this.interval = setInterval(this.countdown, 1000);
    };

    countdown = () => {
        const { order } = this.props;
        const bag = order.bags && order.bags[0] ? order.bags[0] : order;
        const now = moment((bag.production_started_at ? bag.production_started_at : order.delivery_time), 'x');
        const then = moment();

        const duration = moment.duration(then.diff(now)).asMilliseconds();

        const hours = moment.utc(duration).format('H');
        const minutes = moment.utc(duration).format('mm');
        const seconds = moment.utc(duration).format('ss');

        if (
            parseInt(minutes) > 4 &&
            parseInt(seconds) > 0
        ) {
            if (bag.production_started_at) {
                this.setState({ hours, minutes, seconds, delay: true });
            } else {
                this.setState({ hours, minutes, seconds, delay: false });
            }
        } else {
            this.setState({ hours, minutes, seconds });
        }
    };

    handleClickPickup = () => {
        this.setState({ showConfirmationModal: true });
    };

    handleConfirmPickup = () => {
        const { LiveDispatchStore, order } = this.props;
        this.setState({ loading: true });
        LiveDispatchStore.handleConfirmPickupOrder(order.delivery_id, order.order_number).finally(() => {
            this.setState({ loading: false });
        });
        this.setState({ showConfirmationModal: false });
    };

    handleCloseConfirmationModal = () => {
        this.setState({ showConfirmationModal: false });
    };

    render() {
        const {
            delay,
            showConfirmationModal,
            hours,
            minutes,
            seconds
        } = this.state;
        const { order, isNewOrder } = this.props;
        const bag = order.bags && order.bags[0] ? order.bags[0] : order;

        return (
            <Fragment>
                <div
                    className={`${base}__drive-through`}
                >
                    <Fragment>
                            {this.state.loading ? (
                                <ReactLoading
                                    type="spin"
                                    color="black"
                                    height={'10%'}
                                    width={'10%'}
                                    className="loader"
                                />
                            ) : (
                                <Fragment>

                                {isNewOrder && (
                                    <div className={`${base}__loyalty-tier-name ${delay ? 'delay' : ''}`}>                                
                                        CUSTOMER WAITING
                                        <br/>
                                        GO OUTSIDE
                                    </div>
                                )}
                            <div
                                className={`${base}__dine-in-order ${delay ? 'delay' : ''} ${isNewOrder ? 'blink' : ''}`}
                                onClick={this.handleClickPickup}
                                style={{cursor: 'pointer'}}
                            >

                                <div
                                    className={`${base}__drive-through-header display--flex justify--space-between ${delay ? 'delay' : ''}`}
                                >
                                    <div
                                        style={{
                                            width: '32px',
                                            height: '28px',
                                        }}
                                    >
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            src= "https://image.popcontent.link/car.svg"
                                        />
                                    </div>
                                    <div className={`${base}__drive-through-customer-info width--100`}                                    >
                                        <div>
                                            {`${bag.bag_number ? bag.bag_number : bag.order_number}`} { `${bag.customer_name ? bag.customer_name : bag.order_number}`}                                        </div>
                                        <div>
                                            {`${
                                                parseInt(hours) > 0 ? `${hours}:` : ``
                                            }${minutes}:${seconds}`}
                                        </div>
                                    </div>
                                </div>
                                {bag.order_mode == "PANDU_MASUK" ?
                                    <div className='display--flex'>
                                        <div
                                            className={`${base}__drive-through-content display--flex`}
                                        >
                                            {bag.car_details && (
                                                <div>
                                                    {bag.car_details.color} {bag.car_details.make}
                                                    <br/>
                                                    {bag.car_details.number_plate}
                                                </div> 
                                            )}
                                        </div>
                                    </div> :
                                        bag.platform != "Terminal" ?
                                        <div className='display--flex'>
                                            <div
                                                className={`${base}__drive-through-content display--flex`}
                                            >
                                                <div>
                                                    ASK CUSTOMER TO SHOW BAG NUMBER
                                                </div>
                                            </div>
                                        </div> :
                                        null
                                }
                            </div>
                            </Fragment>
                        )}
                        </Fragment>
                </div>

                
                {showConfirmationModal && (
                    <Modal width="700px">
                        <Fragment>
                            {bag.order_mode == "PANDU_MASUK" ?
                                <h1 className="mt0 mbxs">
                                    Bag {bag.bag_number ? bag.bag_number : bag.order_number} PANDU MASUK
                                </h1> :

                                <h1 className="mt0 mbxs">
                                    Bag {bag.bag_number ? bag.bag_number : bag.order_number} - Confirm{' '}
                                    <span className="text--red">
                                        {order.amount_due
                                            ? order.pre_tax_net_total
                                            : ''}
                                    </span>
                                    {`${
                                        order.amount_due ? ' Collected' : ' Picked Up'
                                    }`}
                                </h1>
                            }
                            <br/>
                            {bag.order_mode == "PANDU_MASUK" ?
                                <p style={{fontSize: '20px'}}>
                                    Only mark done if you went outside and given bag to customer! 
                                </p> :
                                <p className="text--sofiapro">
                                    Do you confirm that the right customer has
                                    already paid for their meal and verify their
                                    purchase?
                                </p>
                            }
                            <br/>
                            <button
                                className="btn btn-black display--block width--100 mbs"
                                onClick={() => this.handleConfirmPickup()}
                            >
                                {bag.order_mode == "PANDU_MASUK" ?  "I HAVE GIVEN THE BAG TO CUSTOMER" : "Confirm"}
                            </button>
                            <button
                                className="btn btn-borderless display--block width--100"
                                onClick={this.handleCloseConfirmationModal}
                            >
                                Cancel
                            </button>
                        </Fragment>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

export default DriveThrough;
